import { AccountDetailsFormValues } from '@account/types';
import { InputField } from '@components/utility/inputs';
import { Select } from '@components/utility/selects';
import { useGetRolesQuery } from '@services/userRoles';
import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';

export const PersonalInformation = ({ loading }: { loading?: boolean }) => {
    //#region Data Fetching
    const { data: roles } = useGetRolesQuery(undefined, {
        selectFromResult: (response) => ({
            ...response,
            data: response.data?.map((role) => ({ label: role.label, value: role.value })) ?? [],
        }),
    });
    //#endregion

    //#region Hooks
    const intl = useIntl();
    const { values, errors, touched, handleChange } = useFormikContext<AccountDetailsFormValues>();
    //#endregion

    return (
        <>
            <InputField
                id="first_name"
                name="first_name"
                buffered
                required
                placeholder={intl.formatMessage({
                    id: 'common.firstName.placeholder',
                    defaultMessage: 'Enter first name',
                })}
                fullWidth
                topLabel={intl.formatMessage({ id: 'common.firstName', defaultMessage: 'First Name' })}
                debounceMs={0}
                loading={loading}
            />
            <InputField
                id="last_name"
                name="last_name"
                buffered
                required
                placeholder={intl.formatMessage({
                    id: 'common.lastName.placeholder',
                    defaultMessage: 'Enter last name',
                })}
                fullWidth
                topLabel={intl.formatMessage({ id: 'common.lastName', defaultMessage: 'Last Name' })}
                debounceMs={0}
                loading={loading}
            />
            <Select
                id="role"
                items={roles}
                type="radio"
                placeholder={intl.formatMessage({
                    id: 'common.role.placeholder',
                    defaultMessage: 'Choose a role',
                })}
                size="smallest"
                fullWidth
                boxProps={{
                    className: 'md:col-span-2 w-full',
                }}
                topLabel={intl.formatMessage({ id: 'common.role', defaultMessage: 'Role' })}
                required
                name="role"
                value={values.role ?? ''}
                error={touched.role && !!errors.role}
                helperText={touched.role && errors.role ? errors.role : undefined}
                onChange={handleChange}
                disabled
                loading={loading}
                loadingType="skeleton"
                fcSX={{
                    className: 'md:col-span-2',
                }}
            />
            <InputField
                id="email"
                buffered
                name="email"
                required
                placeholder={intl.formatMessage({
                    id: 'common.email.placeholder',
                    defaultMessage: 'Enter email',
                })}
                fullWidth
                topLabel={intl.formatMessage({ id: 'common.email', defaultMessage: 'Email' })}
                debounceMs={0}
                disabled
                loading={loading}
            />
            <InputField
                id="mobile_phone"
                name="mobile_phone"
                buffered
                placeholder={intl.formatMessage({
                    id: 'common.mobilePhone.placeholder',
                    defaultMessage: 'Enter mobile phone number',
                })}
                fullWidth
                topLabel={intl.formatMessage({ id: 'common.mobilePhoneNumber', defaultMessage: 'Mobile Phone Number' })}
                debounceMs={0}
                loading={loading}
            />
            <InputField
                id="telephone"
                name="telephone"
                buffered
                placeholder={intl.formatMessage({
                    id: 'common.telephone.placeholder',
                    defaultMessage: 'Enter telephone number',
                })}
                fullWidth
                topLabel={intl.formatMessage({ id: 'common.telephoneNumber', defaultMessage: 'Telephone Number' })}
                debounceMs={0}
                loading={loading}
            />
            <InputField
                id="fax"
                name="fax"
                buffered
                placeholder={intl.formatMessage({
                    id: 'common.fax.placeholder',
                    defaultMessage: 'Enter fax number',
                })}
                fullWidth
                topLabel={intl.formatMessage({ id: 'common.fax', defaultMessage: 'Fax' })}
                debounceMs={0}
                loading={loading}
            />
        </>
    );
};
